import React from 'react';

type CalendarView = 'month' | 'week' | 'day';

interface CalendarViewToggleProps {
  currentView: CalendarView;
  onChange: (view: CalendarView) => void;
}

const VIEWS: { value: CalendarView; label: string }[] = [
  { value: 'month', label: 'Month' },
  { value: 'week', label: 'Week' },
  { value: 'day', label: 'Day' },
];

const CalendarViewToggle: React.FC<CalendarViewToggleProps> = ({ currentView, onChange }) => {
  return (
    <div className="flex flex-col lg:flex-row gap-1">
      {VIEWS.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
            currentView === value
              ? 'bg-blue-600 text-white'
              : 'bg-slate-200 text-slate-700 hover:bg-slate-300 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default CalendarViewToggle;
